<sh-popover
  sticky
  label="{{ 'spareParts.filter' | translate }}"
  [position]="position()"
  [target]="targetId()"
>
  <button
    slot="functions"
    id="clear-all-btn"
    class="clear-all-btn"
    (click)="onClickClearAll()"
    (keydown.enter)="onClickClearAll()"
    (keydown.backspace)="onClickClearAll()"
  >
    {{ 'spareParts.clearAll' | translate }}
  </button>

  @for (key of filterModelKeys(); track key) {
    <sh-dropdown
      #dropdown
      display="label"
      [label]="$any(clonedModalFilters())[key].label | translate"
      [value]="$any(clonedModalFilters())[key].selectedValue"
      (value-changed)="
        $any(clonedModalFilters())[key].selectedValue = dropdown.value
      "
    >
      @for (option of $any(clonedModalFilters())[key].options; track option) {
        <sh-menu-item label="{{ option }}"> </sh-menu-item>
      }
    </sh-dropdown>
  }

  <sh-button
    id="spare-parts-popover-cancel-btn"
    slot="footer"
    label="{{ 'spareParts.cancel' | translate }}"
    color="secondary"
    (click)="onCancelFilterClick()"
    (keydown.enter)="onCancelFilterClick()"
    (keydown.backspace)="onCancelFilterClick()"
  ></sh-button>

  <sh-button
    id="spare-parts-popover-apply-btn"
    slot="footer"
    label="{{ 'spareParts.apply' | translate }}"
    (click)="onApplyFilterClick()"
    (keydown.backspace)="onApplyFilterClick()"
  ></sh-button>
</sh-popover>
